// extracted by mini-css-extract-plugin
export default {"user-img":"common_user-img__WKURb"};